import en from './locales/en.json';

const messages = {
  en,
};
export default messages;
